import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileService } from 'src/app/api/profile.service';
import { AuthService } from 'src/app/api/auth.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { StorageService } from 'src/app/services/storage.service';
import { HCaptchaService } from 'src/app/services/hcaptcha.service';

@Component({
  selector: 'auth-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  @Input() referralId: string;

  loading = false;
  error: string = null;

  form = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    password: [''],
  });

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private profileService: ProfileService,
    private storageService: StorageService,
    private hCaptchaService: HCaptchaService,
    private ga: GoogleAnalyticsService) { }

  ngOnInit() {
    this.checkQueryParams();
  }

  checkQueryParams() {
    // email
    const email = this.route.snapshot.queryParamMap.get('email');
    if (email) {
      this.email.setValue(email);
    }
  }

  onSubmit() {
    this.hCaptchaService.generatePassiveCaptcha();

    this.error = null;
    if (this.form.valid) {
      this.loading = true;
      this.profileService.registerUser({
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        email: this.email.value,
        password: this.password.value,
      }, this.referralId).subscribe(response => {
        this.auth.setCredentials(this.email.value, this.password.value).login().subscribe(_response => {
          this.loading = false;
          this.ga.sendEvent('Account', {action: 'Sign Up', label: 'Registered'});
          this.router.navigate(['/settings']);
        }, err => {
          this.loading = false;
          this.error = err.errors[0].message;
        });
      }, err => {
        this.loading = false;
        this.error = err.errors[0].message;
      });
    } else {
      this.error = 'Please fill out all the required fields';
    }
  }

  get firstName() { return this.form.get('firstName'); }
  get lastName() { return this.form.get('lastName'); }
  get email() { return this.form.get('email'); }
  get password() { return this.form.get('password'); }

}
